import Carousel from "react-multi-carousel";
import { memo } from "react";
import Skeleton from "@mui/material/Skeleton";
import "react-multi-carousel/lib/styles.css";
import { useGetBannerListQuery } from "app/slices/BannerListSlice";
import { Link } from "react-router-dom";

const CaroHero = () => {
  //
  const { isLoading, data, isError } = useGetBannerListQuery();
  //
  //
  //
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 499, min: 0 },
      items: 1,
      partialVisibilityGutter: 30,
    },
  };

  return (
    <Carousel
      rewindWithAnimation={true}
      partialVisible={true}
      responsive={responsive}
      swipeable={true}
      showDots={false}
      autoPlay={true}
      ssr={true}
      infinite={true}
      autoPlaySpeed={4000}
      minimumTouchDrag={20}
      customTransition="all .6s ease-out"
      transitionDuration={500}
      containerClass="carousel-container"
      removeArrowOnDeviceType={["tablet", "mobile"]}
      dotListClass="custom-dot-list-style"
      itemClass="carousel-item-padding-20-px"
      partialVisibilityGutter={35}
      rewind={true}
      pauseOnHover={false}
    >
      {isError && <p>{JSON.stringify(isError)}</p>}
      {isLoading && (
        <div className="h-[600px]">
          <Skeleton animation="wave" height={200} />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" height={200} />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </div>
      )}
      {data?.map((item, index) => {
        return (
          <Link
            to={item?.banner_link}
            className="relative block mx-1 "
            key={item.id}
          >
            <img
              className="md:h-full w-full"
              title={item?.image_text}
              src={item?.background_url}
              alt={(item.image_text, "alt text")}
              loading="eager"
              fetchpriority="high"
            />
          </Link>
        );
      })}
    </Carousel>
  );
};

export default memo(CaroHero);
